import React from "react";
import { Outlet } from "react-router-dom";
import BrandBar from "./BrandBar";
import TopBar from "./TopBar";
import Footer from "./Footer";
import "../style/MainLayout.css";

export default function MainLayout() {
  return (
    <div className="layout-shell">
      <BrandBar />
      <TopBar />
      <main className="layout-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
